var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('header-bar'),_c('div',{staticClass:"navwrap"}),_c('div',{staticClass:"med-wrapper-box"},[_c('div',[_c('Content',{staticClass:"m-content-wrapper"},[_c('router-view')],1)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }